<template>
  <div id="footer" class="container-fluid">
    <div class="logo">
      <img src="@/assets/img/logo_white.png" alt="logo图"  style="margin: 0 auto; width: 300px;" >
    </div>
    <p class="title">深圳市中望信息科技有限公司</p>
    <p class="address_tel_fax">
      <span>地址：深圳市罗湖区南湖街道嘉北社区嘉宾路2002号彭年广场4208</span>
     <!-- <span>ROOM 4, 16/F, HO KING COMMERCIAL CENTRE, 2-16 FAYUEN STREET, MONGKOK KOWLOON, HONG KONG</span> -->
      <span>Tel：+86 15112517151</span>
    </p>
   <p class="email_wx">
      <span>邮箱：c506971402@hotmail.com </span>
      <a target="_blank" href="https://beian.miit.gov.cn">粤ICP备2023101801号</a>
    </p>
    <p class="copy">
      Copyright &copy; 2018 - {{ new Date().getFullYear() }} 深圳市中望信息科技有限公司
    </p>
  </div>
</template>
<script>
export default {
  name: "Footer",
  data() {
    return {};
  }
};
</script>
<style scoped>
#footer {
  width: 100%;
  height: 100%;
  color: #fff;
  background: #474747;
  overflow: hidden;
  text-align: center;
}
.logo {
/*  width: 95px;
  height: 45px; */
  margin: 50px auto 20px;
  text-align: center;
}
.title {
  font-size: 25px;
  margin-bottom: 20px;
}
.address_tel_fax {
  color: #d3d3d3;
  font-size: 14px;
  margin: 10px 0;
}
.email_wx {
  color: #d3d3d3;
  font-size: 14px;
}
.copy {
  color: #d3d3d3;
  font-size: 14px;
  margin: 50px 0 10px;
}
@media screen and (max-width: 997px) {
  .title {
    font-size: 20px;
  }
  .address_tel_fax {
    font-size: 12px;
  }
  .email_wx {

  font-size: 12px;
}
.copy {
  font-size: 12px;
  margin: 30px 0 10px;
}
}
</style>




// WEBPACK FOOTER //
// src/components/Footer.vue